export default __webpack_public_path__ + "38a99185f108f616284f35323b2b6d8b.svg";